import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import styled from 'styled-components';
import { useId } from '../hooks/useId.js';
import { useField } from '../Field/FieldContext.js';
import { Typography } from '../Typography/Typography.js';
import { BaseCheckbox } from '../BaseCheckbox/BaseCheckbox.js';
import { Field } from '../Field/Field.js';
import { Flex } from '../Flex/Flex.js';
import { Box } from '../Box/Box.js';
import { FieldHint } from '../Field/FieldHint.js';
import { FieldError } from '../Field/FieldError.js';

const CheckboxLabel = styled(Typography) `
  display: flex;
  align-items: flex-start;
  * {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
`;
const CheckboxTick = React.forwardRef((props, forwardedRef) => {
    const { id } = useField();
    return jsx(BaseCheckbox, { ref: forwardedRef, id: id, ...props });
});
const Checkbox = React.forwardRef(({ children, disabled = false, id, hint, error, ...props }, forwardedRef) => {
    const generatedId = useId(id);
    let ariaDescription;
    if (error) {
        ariaDescription = `${generatedId}-error`;
    }
    else if (hint) {
        ariaDescription = `${generatedId}-hint`;
    }
    return (jsx(Field, { id: generatedId, hint: hint, error: error, children: jsxs(Flex, { direction: "column", alignItems: "stretch", gap: 1, children: [jsxs(CheckboxLabel, { as: "label", textColor: "neutral800", disabled: disabled, children: [jsx(CheckboxTick, { ref: forwardedRef, disabled: disabled, "aria-describedby": ariaDescription, ...props }), jsx(Box, { paddingLeft: 2, children: children })] }), jsx(FieldHint, {}), jsx(FieldError, {})] }) }));
});

export { Checkbox };
